





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { format, fromUnixTime } from 'date-fns';
import i18n from 'vue-i18n';
import { get, matches } from 'lodash';
import Vue from 'vue';
import axios from 'axios';
import Router from 'vue-router';
import IdentityCreateEdit from '@/components/Templates/Admin/Access/IdentityCreateEdit/IdentityCreateEdit.vue';
import CoNote from '@/components/Organisms/co-note/CoNote.vue';
import CoNoteCreate from '@/components/Organisms/co-note-create/CoNoteCreate.vue';
import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoForm from '@/components/Molecules/co-form/CoForm.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoUserProfileEditor from '@/components/Organisms/co-user-profile-editor/CoUserProfileEditor.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoCopy from '@/components/Atoms/co-copy/CoCopy.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoTag from '@/components/Atoms/co-tag/CoTag.vue';
import EventBus from '@/eventBus';
import CoPaymentDetails from '@/components/Molecules/co-payment-details/CoPaymentDetails.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoHeader from '@/components/Molecules/co-header/CoHeader.vue';
import CoSubscriptionStatusModal from '@/components/Organisms/co-subscription-status-modal/CoSubscriptionStatusModal.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoMatch from '@/components/Molecules/co-match/CoMatch.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import { formatLinkLabel } from '@/utils/linkLabel';

Vue.use(Router);

interface UserMembership {
    subscriptionStatus: string;
    stripeCustomerLink: string;
    stripeCustomerID: string;

    currentBillingPeriodStart: number;
    currentBillingPeriodEnd: number;

    billingCycleAnchor: number;

    subscriptionCancelAt: number; // timestamp when subscription will be cancelled
    subscriptionCanceledAt: number; // timestamp when subscription was cancelled
    subscriptionStartDate: number; // timestamp when subscription was created
    subscriptionEndedAt: number; // timestamp when subscription was ended
    subscriptionCreated: number; // timestamp when subscription was created

    collectionMethod: string;

    parentPlanUserID: string;
}

export default {
    name: 'MemberAccountV2',
    components: {
        CoText,
        CoSubscriptionStatusModal,
        CoDropdown,
        CoDropdownItem,
        CoConfirmation,
        CoThumbnail,
        CoPaymentDetails,
        CoDate,
        CoSkeleton,
        CoTippy,
        CoForm,
        CoFormGroup,
        CoInput,
        CoHeadline,
        CoLink,
        CoNoteCreate,
        CoNote,
        CoCard,
        IdentityCreateEdit,
        CoUserProfileEditor,
        CoTag,
        CoMatch,
        CoModal,
    },
    data() {
        return {
            loading: false,
            loadingForRejectOrApprove: false,

            title: this.$tc('labels.member', 1),
            plan: null,
            planLoading: false,
            user: {},

            userNotes: [],
            showErrors: false,
            isMe: false,
            loader: false,
            deleting: false,
            ID: this.$route.params.ID,
            paymentMethods: [],
            userStatus: [
                {
                    displayText: this.$t('userstatuslabels.0'),
                    value: 0,
                    variant: 'success',
                },
                { displayText: this.$t('userstatuslabels.3'), value: 3, variant: 'warning' },
                {
                    displayText: this.$t('userstatuslabels.4'),
                    value: 4,
                    variant: 'danger',
                },
                {
                    displayText: this.$t('userstatuslabels.5'),
                    value: 5,
                    variant: 'warning',
                },
                {
                    displayText: this.$t('userstatuslabels.7'),
                    value: 7,
                    variant: 'warning',
                },
                {
                    displayText: 'Banned',
                    value: 8,
                    variant: 'danger',
                },
            ],

            // feed
            feed: [],
            feedNextPage: null,
            projects: [],
            selectedStatus: {},
            initialStatus: {},
            jobs: null,
            billingAddress: {},
            registrationAddress: null,

            upcomingInvoice: null,
            upcomingInvoiceLoading: false,

            membership: {} as UserMembership | null,
            membershipStatusIcon: 'check-circle',
            membershipLoading: false,

            // timepasses
            activeTimePass: null,
            timePassLoading: false,

            accessIdentities: [],
            loadingIdentities: false,
            currentIdentity: null, // Identity to edit

            genderOptions: {
                x: this.$t('labels.nonbinary'),
                f: this.$t('labels.female'),
                m: this.$t('labels.male'),
                u: this.$t('labels.prefernottosay'),
            },
            metadataModalMode: 'add',
            metadataForm: {
                key: '',
                value: '',
            },
            metadataFormError: '',
            metadataSaving: false,
            metadataDeletingKey: null,
            metadataOriginalKey: null,
            matchesLoading: false,
            matches: [],
            passwordResetLoading: false, // Prevent duplicate admin reset emails while the reset request is active.
        };
    },
    computed: {
        customFields() {
            const fields = [...(this.user.Fields || [])];

            // stable sort by field sort-order and then by name
            return fields.sort((a, b) => {
                if (a.SortOrder === b.SortOrder) {
                    return a.Label.localeCompare(b.Label);
                }
                return a.SortOrder - b.SortOrder;
            });
        },
        metadataEntries(): Array<{ key: string; value: string }> {
            const metadata = (this.user && this.user.Metadata) || {};

            return Object.keys(metadata)
                .sort((a, b) => a.localeCompare(b))
                .map((key) => ({
                    key,
                    value: metadata[key] != null ? String(metadata[key]) : '',
                }));
        },
        metadataModalTitle() {
            return this.metadataModalMode === 'edit' ? this.$t('metadataEditTitle') : this.$t('metadataAddTitle');
        },
        userName() {
            if (this.user.Profile && this.user.Profile.FirstName && this.user.Profile.LastName) {
                return `${this.user.Profile.FirstName} ${this.user.Profile.LastName}`;
            }

            if (this.user.Profile && this.user.Profile.Name) {
                return this.user.Profile.Name;
            }

            return this.user.Email;
        },
        titleForNextInvoice() {
            if (this.upcomingInvoiceLoading) {
                return 'Loading...';
            }

            if (this.upcomingInvoice) {
                let timestamp = 0;
                // if this.upcomingInvoice.Created is a string convert it to a number
                if (typeof this.upcomingInvoice.Created === 'string') {
                    timestamp = parseInt(this.upcomingInvoice.Created, 10);
                } else {
                    timestamp = this.upcomingInvoice.Created;
                }

                // if timestamp is in milliseconds convert it to seconds
                if (timestamp > 9999999999) {
                    timestamp /= 1000;
                }

                return `${format(fromUnixTime(timestamp), 'hh:mm yyyy.MM.dd')}`;
            }
            return 'No upcoming invoice';
        },
        isSpaceAdmin(): boolean {
            const permissions = this.user && this.user.Permissions ? this.user.Permissions : '';
            return permissions.includes('space_admin');
        },
        billingAdminID() {
            return this.$store?.state?.space_configuration_admin?.PaymentMethodeCreatedBy || null;
        },
        meID() {
            return this.$store?.state?.me?.ID || null;
        },
    },
    created() {
        const { ID } = this.$route.params;
        this.adminGetUserByID(ID);

        // this.membership = {
        //     status: 'UNSPECIFIED',
        //     stripeCustomerLink: null,
        //     stripeCustomerID: 'cus-H4Z2Z2',

        //     currentBillingPeriodStart: null, // unix timestamp in seconds when the current billing period started
        //     currentBillingPeriodEnd: null, // unix timestamp in seconds when the current billing period ends
        //     billingCycleAnchor: null, // unix timestamp in seconds when the billing cycle anchor was set
        //     cancelAt: null, // unix timestamp in seconds when the subscription will be canceled
        //     canceledAt: null, // unix timestamp in seconds when the subscription was canceled
        //     startDate: null, // unix timestamp in seconds when the subscription was created
        //     endedAt: null, // unix timestamp in seconds when the subscription ended
        //     created: null, // unix timestamp in seconds when the membership was created
        // };
    },
    watch: {
        user(newVal, oldVal) {
            if (newVal && newVal.ID) {
                this.getUserPaymentMethods(newVal.ID);
                this.getPlanByID(newVal.ID);
                this.getMembership(newVal.ID);
                this.getFeedForUser(newVal.ID);
                this.getProjectsForUser(newVal.ID);
                this.getUserNotes(newVal.ID);
                this.getUserAdresses(newVal.ID);
                this.getInvoicesByID(newVal.ID);
            }
        },
    },
    mounted() {
        this.getActiveTimePass();

        this.$unleash.on('ready', () => {
            if (this.$unleash.isEnabled('frontend.access-management.admin')) {
                this.getAccessIdentities(this.user.ID);
            }
        });
    },
    methods: {
        get,
        formatLinkLabel,

        displayMultiSelectValues(input: string) {
            if (!input) return '';
            // replace commas with ', '
            const output = input.replace(/,/g, ', ');
            return output;
        },
        userUpdated(usr) {
            const { ID } = this.$route.params;
            this.adminGetUserByID(ID);
            this.$refs.userprofileditor.hide();
        },
        showuserprofileditor() {
            this.$refs.userprofileditor.show();
        },
        accessKeyModalClosed() {
            this.currentIdentity = null;
        },
        cancelAccessKeyChanges() {
            this.$refs.accessIdentityModal.hide();
            this.currentIdentity = null;
        },
        accessChangesSaved() {
            EventBus.$emit('INFO', {
                Message: this.$t('messages.changessaved'),
                Details: '',
            });
            this.$refs.accessIdentityModal.hide();
            // replace current identity in the list
            this.getAccessIdentities(this.user.ID);
            this.currentIdentity = null;
        },
        accessChangesFailed(error) {
            let errMsg = this.$t('errors.failedGeneric');

            const customErrorCode = get(error, 'response.data.code', null);
            if (customErrorCode) {
                errMsg = this.$t(`errors.accessManagement.${customErrorCode}`) || errMsg;
            }
            EventBus.$emit('ERROR', {
                Message: errMsg,
                Details: '',
            });
        },
        getAccessKeyName(identity) {
            if (!identity) {
                return '';
            }
            if (!identity.Tags || identity.Tags.length === 0) {
                return '';
            }
            const key = identity.Tags[0];
            return key ? key.Name : this.$t('labels.assignkey');
        },
        createAccessIdentity() {
            this.currentIdentity = {
                UserID: this.user.ID,
                FirstName: this.user.Profile ? this.user.Profile.FirstName : '',
                LastName: this.user.Profile ? this.user.Profile.LastName : '',
                DisplayName: this.user.Profile ? this.user.Profile.Name : '',
                Email: this.user.Email,
            };
            this.$refs.accessIdentityModal.show();
        },
        editeAccessIdentity(identity) {
            if (!identity) {
                return;
            }
            this.currentIdentity = identity;
            if (this.currentIdentity.UserID !== this.user.ID) {
                this.currentIdentity.UserID = this.user.ID;
            }
            this.currentIdentity.FirstName = this.user.Profile ? this.user.Profile.FirstName : '';
            this.currentIdentity.LastName = this.user.Profile ? this.user.Profile.LastName : '';
            this.currentIdentity.DisplayName = this.user.Profile ? this.user.Profile.Name : '';
            this.currentIdentity.Email = this.user.Email;
            this.$refs.accessIdentityModal.show();
        },
        setBreadcrumbs() {
            let name = '';
            if (!this.user.Profile) {
                name = this.user.Email;
            } else {
                name = `${this.user.Profile.FirstName} ${this.user.Profile.LastName}`;
                if (name === ' ') {
                    name = this.user.Profile.Name;
                }

                if (name === ' ') {
                    this.name = this.user.Email;
                }
            }
            this.$store.commit('SET_BREADCRUMBS', [
                {
                    text: this.$t('labels.manage'),
                    to: '/admin',
                },
                {
                    text: this.$t('labels.members'),
                    to: '/admin/community/member/list',
                },
                {
                    text: name,
                },
            ]);
        },
        setMembershipStatusIcon() {
            if (
                !this.membership ||
                !this.membership.subscriptionStatus ||
                this.membership.subscriptionStatus === 'UNSPECIFIED'
            ) {
                this.membershipStatusIcon = 'check-circle';
            }
            switch (this.membership.subscriptionStatus) {
                case 'ACTIVE':
                    this.membershipStatusIcon = 'check-circle';
                    break;
                case 'TRIALING':
                    this.membershipStatusIcon = 'check-circle';
                    break;
                case 'PAST_DUE':
                    this.membershipStatusIcon = 'exclamation-triangle';
                    break;
                case 'UNPAID':
                    this.membershipStatusIcon = 'exclamation-triangle';
                    break;
                case 'CANCELLED':
                    this.membershipStatusIcon = 'exclamation-triangle-fill';
                    break;
                case 'INCOMPLETE':
                    this.membershipStatusIcon = 'clock-circle';
                    break;
                case 'INCOMPLETE_EXPIRED':
                    this.membershipStatusIcon = 'exclamation-triangle';
                    break;
                default:
                    this.membershipStatusIcon = 'exclamation-triangle';
            }
        },
        formatDate(date) {
            if (!date) {
                return '-';
            }

            // parse string to int
            const parsedInt = parseInt(date, 10);
            const parsedDate = fromUnixTime(parsedInt);

            return format(parsedDate, 'HH:mm yyyy.MM.dd');
        },
        getMembership(ID) {
            this.membershipLoading = true;
            axios({
                method: 'GET',
                url: `/admin/community/member/membership/${ID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        // cast response to UserMembership
                        this.membership = response.data as UserMembership;
                    }
                })
                .catch((error) => {
                    this.membership = {
                        status: 'UNSPECIFIED',
                        stripeCustomerLink: null,
                        stripeCustomerID: '',

                        currentBillingPeriodStart: null, // unix timestamp in seconds when the current billing period started
                        currentBillingPeriodEnd: null, // unix timestamp in seconds when the current billing period ends
                        billingCycleAnchor: null, // unix timestamp in seconds when the billing cycle anchor was set
                        cancelAt: null, // unix timestamp in seconds when the subscription will be canceled
                        canceledAt: null, // unix timestamp in seconds when the subscription was canceled
                        startDate: null, // unix timestamp in seconds when the subscription was created
                        endedAt: null, // unix timestamp in seconds when the subscription ended
                        created: null, // unix timestamp in seconds when the membership was created
                    };
                    console.log(error);
                })
                .finally(() => {
                    this.setMembershipStatusIcon();
                    this.membershipLoading = false;
                });
        },

        displayMonth(expMonth) {
            if (expMonth.length == 1) {
                let newMonth = '0';
                newMonth += expMonth;
                return newMonth;
            }
            return expMonth;
        },

        getUserPaymentMethods(userID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/payment/stripe/payment-methods/${userID}?UserID=${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.paymentMethods = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goToInvoicesOfUser() {
            this.$router.push(`/admin/community/member/invoices/${this.user.ID}`);
        },

        addNewNote() {
            this.getUserNotes(this.user.ID);
        },

        viewProfile(slug) {
            this.$router.push(`/profile/${slug}`);
        },
        deleteUser() {
            if (!this.user || !this.user.ID) {
                return;
            }
            this.deleting = true;
            this.$store
                .dispatch('adminDeleteUser', this.user.ID)
                .then(() => {
                    const message = {
                        Message: this.$t('messages.userDeleted'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.$router.push(`/admin/community/member/list`);
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.userDeleteFailed'),
                        Details: get(error, 'response.data', ''),
                    };
                    EventBus.$emit('ERROR', message);
                })
                .finally(() => {
                    this.deleting = false;
                });
        },

        adminGetUserByID(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.$data.user = response;

                    if (this.user.Profile && this.user.Profile.Name) {
                        if (this.user.Profile.FirstName === '' || this.user.Profile.FirstName == null) {
                            const names = this.user.Profile.Name.split(' ');
                            this.user.Profile.FirstName = names[0];
                            names.splice(0, 1);
                            if (names.length > 1) {
                                this.user.Profile.LastName = names.join(' ');
                            } else {
                                this.user.Profile.LastName = names[0];
                            }
                        }
                        if (this.user.Status) {
                            this.selectedStatus = this.userStatus.find((x) => x.value === this.user.Status);
                            if (!this.selectedStatus) {
                                this.selectedStatus = this.userStatus[0];
                            }
                        } else {
                            // eslint-disable-next-line prefer-destructuring
                            this.selectedStatus = this.userStatus[0];
                        }
                        this.initialStatus = this.selectedStatus;

                        this.setBreadcrumbs();
                    }
                    if (this.$unleash.isEnabled('frontend.access-management.admin')) {
                        this.getAccessIdentities(this.user.ID);
                    }
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.userDataLoadFailed'),
                        Details: error.response.data,
                    };
                    EventBus.$emit('ERROR', message);
                    this.$router.push(`/admin/community/member/list`);
                });
        },

        getUserNotes(userID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/notes/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        const notes = response.data;
                        // sort notes by date desc
                        notes.sort((a, b) => b.Timestamp - a.Timestamp);
                        this.userNotes = notes;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getUserAdresses(userID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/community/member/billing-address/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data && Object.keys(response.data).length > 0) {
                        this.billingAddress = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });

            axios({
                method: 'GET',
                url: `/admin/community/member/registration-address/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data && Object.keys(response.data).length > 0) {
                        this.registrationAddress = response.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getProjectsForUser(userID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/user/profile/projects/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    let tmp = response.data.objects; // todo support pagination

                    this.projects = tmp;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        getFeedForUser(userID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/user/profile/feed/${userID}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.feed = response.data.objects;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        takeContact(userObj) {
            const thread = {
                Participants: [this.$store.state.me.ID, userObj.ID],
            };
            axios({
                method: 'POST',
                url: '/chat/t',
                withCredentials: true,
                data: JSON.stringify(thread),
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        const routeData = this.$router.resolve(`/messenger/${response.data.ID}`);
                        window.open(routeData.href, '_blank');
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getPlanByID(id) {
            this.planLoading = true;
            axios({
                method: 'GET',
                url: `/admin/community/member/plan?userid=${id}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.plan = response.data.current.Plan;
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.planLoading = false;
                });
        },

        getActiveTimePass() {
            this.timePassLoading = true;
            axios
                .get(`/admin/time-pass/active/${this.$route.params.ID}`)
                .then((response) => {
                    this.activeTimePass = response.data;
                })
                .catch((error) => {
                    this.activeTimePass = null;
                    console.error(error);
                    this.errorMsg = this.$t('messages.timepassWalletLoadFailed');
                })
                .finally(() => {
                    this.timePassLoading = false;
                });
        },
        saveBillingAddress(address) {
            this.loading = true;

            axios({
                method: 'PUT',
                url: `/admin/community/member/billing-address/${this.user.ID}`,
                data: JSON.stringify(address),
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const msg = {
                        Message: this.$t('messages.billingAddressUpdated'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', msg);
                    this.getUserAdresses(this.user.ID);
                    this.$bvModal.hide('modal-edit-billing-address');
                    this.loading = false;
                    //refresh the membership data
                    this.getMembership(this.user.ID);
                })
                .catch((error) => {
                    this.loading = false;

                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.billingAddressUpdateFailed'),
                        Details: null,
                    });
                });
        },
        saveRegistrationAddress(address) {
            this.loading = true;
            axios({
                method: 'PUT',
                url: `/admin/community/member/registration-address/${this.user.ID}`,
                data: JSON.stringify(address),
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const msg = {
                        Message: this.$t('messages.registrationAddressUpdated'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', msg);
                    this.registrationAddress = address;
                    this.$bvModal.hide('modal-edit-registration-address');
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;

                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.registrationAddressUpdateFailed'),
                        Details: null,
                    });
                });
        },
        cancelBillingAddress() {
            this.$bvModal.hide('modal-edit-billing-address');
        },
        cancelRegistrationAddress() {
            this.$bvModal.hide('modal-edit-registration-address');
        },

        getCardText(brand) {
            switch (brand) {
                case 'amex':
                    return 'American Express';
                case 'diners':
                    return 'Diners';
                case 'discover':
                    return 'Discover';
                case 'jcb':
                    return 'JCB';
                case 'mastercard':
                    return 'Mastercard';
                case 'unionpay':
                    return 'UnionPay';
                case 'visa':
                    return 'VISA';
                case 'maestro':
                    return 'Maestro';
                case 'sepa_debit':
                    return 'Sepa Debit';
            }
        },

        getInvoicesByID(userID) {
            this.upcomingInvoiceLoading = true;
            axios({
                method: 'GET',
                url: `/admin/payment/stripe/invoices/${userID}`,
                timeout: 5000,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data && response.data.UpcomingInvoice) {
                        this.upcomingInvoice = response.data.UpcomingInvoice;
                        this.upcomingInvoice.Created = this.upcomingInvoice.Created * 1000;
                    }
                    this.upcomingInvoiceLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.upcomingInvoiceLoading = false;
                });
        },
        openModal(status) {
            this.selectedStatus = this.userStatus.find((s) => s.value === status);

            this.$refs['subscription-status-modal'].show();
        },
        discardStatus() {
            this.selectedStatus = this.initialStatus;
            this.$refs['subscription-status-modal'].hide();
        },
        confirmChangeStatus() {
            this.loading = true;
            this.user.Status = this.selectedStatus.value;

            this.$store
                .dispatch('adminUpdateOtherUser', this.user)
                .then((response) => {
                    // todo delete previuos file
                    const message = {
                        Message: this.$t('messages.accountDetailsUpdated'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.initialStatus = this.selectedStatus;

                    this.$refs['subscription-status-modal'].hide();
                    this.$data.loader = false;
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.accountDetailsUpdateFailed'),
                        Details: error.response.data,
                    };
                    EventBus.$emit('ERROR', message);
                    this.$refs['subscription-status-modal'].hide();
                    this.$data.loader = false;
                });
        },
        detachPaymentMethod(paymentMethodID) {
            this.loading = true;
            this.$store
                .dispatch('detachPaymentMethodAdmin', { userId: this.user.ID, methodID: paymentMethodID })
                .then(() => {
                    this.loading = false;
                    // delete payment method from list
                    this.paymentMethods = this.paymentMethods.filter((pm) => pm.ID !== paymentMethodID);
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.paymentMethodDetached'),
                        Details: null,
                    });
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.paymentMethodDetachFailed'),
                        Details: null,
                    });
                    this.loading = false;
                });
        },

        approveUser() {
            this.loadingForRejectOrApprove = true;

            const data = {
                userID: this.user.ID,
            };

            axios({
                method: 'POST',
                url: `/admin/community/member/approve`,
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const message = {
                        Message: this.$t('messages.userApproved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.adminGetUserByID(this.user.ID);
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.userApprovalFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', message);
                    console.log(error);
                })
                .finally(() => {
                    this.loadingForRejectOrApprove = false;
                });
        },

        rejectUser() {
            this.loadingForRejectOrApprove = true;
            const data = {
                userID: this.user.ID,
            };

            axios({
                method: 'POST',
                url: `/admin/community/member/reject`,
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    const message = {
                        Message: this.$t('messages.userRejected'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.$router.push('/admin/community/member/list');
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.userRejectionFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', message);
                    console.log(error);
                })
                .finally(() => {
                    this.loadingForRejectOrApprove = false;
                });
        },

        getAccessIdentities(id) {
            this.loadingIdentities = true;
            axios({
                method: 'GET',
                url: `/admin/space/access/identity/by-userid/${id}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.accessIdentities = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching access identities:', error);
                })
                .finally(() => {
                    this.loadingIdentities = false;
                });
        },
        async showMatchingProfiles() {
            this.matchesLoading = true;
            this.$refs.matchModal.show();
            try {
                const userMatches = await axios.get(`/admin/community/member/matches/${this.user.ID}`);
                this.matches = userMatches.data;
            } catch (error) {
                console.error('Error fetching matching profiles:', error);
            }
            this.matchesLoading = false;
        },
        requestPasswordReset(email) {
            const normalizedEmail = email ? email.toLowerCase().trim() : '';
            if (this.passwordResetLoading || !normalizedEmail) return null;
            this.passwordResetLoading = true;
            const data = JSON.stringify({ Email: normalizedEmail });
            axios({
                method: 'POST',
                url: '/user/reset-password',
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    const message = {
                        Message: this.$t('messages.passwordResetAdminLinkSent'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                })
                .catch(() => {
                    const message = {
                        Message: this.$t('messages.passwordResetAdminLinkSendFailed'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', message);
                })
                .finally(() => {
                    this.passwordResetLoading = false;
                });
            return null;
        },
    },
};
